import { getAuthHeader } from '@/utils';
import { BASE_URL } from '@core/constants';

export async function getusersList() {
  try {
    const response = await fetch(BASE_URL + 'users-list/', {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        ...getAuthHeader(),
      },
    });
    if (!response.ok) {
      throw new Error(JSON.stringify(response));
    }
    const data = await response.json();
    console.log(data);
    return data;
  } catch (error) {
    console.error('Error creating advance: ', error);
    return { type: 'error', message: 'Error creando anticipo' };
  }
}

/**
 * Get single user data
 * @author gabrielm
 * @param {string} id
 */
export async function getUser(id) {
  try {
    const response = await fetch(`${BASE_URL}users/${id}/`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        ...getAuthHeader(),
      },
    });
    if (!response.ok) {
      throw new Error(JSON.stringify(response));
    }
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error creating advance: ', error);
    return { type: 'error', message: 'Error creando anticipo' };
  }
}

/**
 * Update user
 * @author gabrielm
 * @param {string} id
 * @param {object} data
 */
export async function updateUser(id, data) {
  try {
    // DEBUG: log request payload for diagnosis

    console.debug('DEBUG:fetch updateUser', { url: `${BASE_URL}users/${id}/`, data });
    const response = await fetch(`${BASE_URL}users/${id}/`, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
        ...getAuthHeader(),
      },
      body: JSON.stringify(data),
    });
    // try to parse response body for debugging even on error
    const text = await response.text();
    let responseData = null;
    try {
      responseData = text ? JSON.parse(text) : null;
    } catch (e) {
      responseData = text;
    }
    if (!response.ok) {
      console.error('DEBUG:updateUser response not ok', {
        status: response.status,
        body: responseData,
      });
      throw new Error(JSON.stringify({ status: response.status, body: responseData }));
    }

    console.debug('DEBUG:updateUser response', responseData);
    return responseData;
  } catch (error) {
    console.error('Error creating advance: ', error);
    return { type: 'error', message: 'Error creando anticipo' };
  }
}

/**
 * Create user
 * @param {object} data
 */
export async function createUser(data) {
  try {
    const response = await fetch(`${BASE_URL}users/`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        ...getAuthHeader(),
      },
      body: JSON.stringify(data),
    });
    if (!response.ok) {
      throw new Error(JSON.stringify(response));
    }
    const responseData = await response.json();
    return responseData;
  } catch (error) {
    console.error('Error creating user: ', error);
    return { type: 'error', message: 'Error creando usuario' };
  }
}

export async function getUsersClientList(userID, clientID) {
  const queryParams = new URLSearchParams();
  if (userID) {
    queryParams.append('user', userID);
  }
  if (clientID) {
    queryParams.append('company_client', clientID);
  }
  const url = `${BASE_URL}insurance/user-client/?${queryParams.toString()}`;
  try {
    const response = await fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        ...getAuthHeader(),
      },
    });
    if (!response.ok) {
      throw new Error(JSON.stringify(response));
    }
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error fetching CompanyClientUsers: ', error);
    return { type: 'error', message: 'Error obteniendo asociaciones usuario-cliente' };
  }
}

/**
 * Get users associated to a company client (returns CompanyClientUsers entries)
 * @param {number|string} clientID
 */
export async function getUsersByClient(clientID) {
  // Delegate to unified function
  return await getUsersClientList(null, clientID);
}

export async function saveUserClient({ userID, clientsID }) {
  try {
    const response = await fetch(BASE_URL + 'insurance/user-client/', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        ...getAuthHeader(),
      },
      body: JSON.stringify({
        user: userID,
        company_client: clientsID,
      }),
    });
    if (!response.ok) {
      throw new Error(JSON.stringify(response));
    }
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error creating advance: ', error);
    return { type: 'error', message: 'Error creando anticipo' };
  }
}

/**
 * Remove association between a user and a specific company client.
 * Implementation: fetch current associations for the user and POST back the list
 * without the removed client (backend endpoint replaces associations).
 * @param {{userID:string, clientID:number|string}}
 */
export async function removeUserFromClient({ userID, clientID }) {
  try {
    // fetch current associations for the user
    const current = await getUsersClientList(userID, null);
    const entries = Array.isArray(current)
      ? current
      : Array.isArray(current?.results)
        ? current.results
        : [];
    const clientIds = Array.from(
      new Set(
        (entries || [])
          .map(r => r.company_client || r.company_client_id || r.company_client)
          .filter(Boolean)
      )
    );

    // remove the target client
    const filtered = clientIds.filter(id => String(id) !== String(clientID));

    // POST back using existing create endpoint which replaces associations for the user
    const response = await fetch(BASE_URL + 'insurance/user-client/', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        ...getAuthHeader(),
      },
      body: JSON.stringify({ user: userID, company_client: filtered }),
    });

    if (!response.ok) {
      const data = await response.json().catch(() => ({}));
      throw new Error(data.error || data.message || 'Error updating user-client associations');
    }

    return await response.json();
  } catch (error) {
    console.error('Error removing user from client: ', error);
    return { type: 'error', message: 'Error removing user from client' };
  }
}

/**
 * Get profile picture of current user
 * @author gabrielm
 */
export async function getProfilePicture() {
  try {
    const response = await fetch(BASE_URL + 'insurance/profile-picture/', {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        ...getAuthHeader(),
      },
    });

    if (!response.ok) {
      throw new Error(JSON.stringify(response));
    }

    /** @type {{ profile_picture: string|null }} */
    const data = await response.json();
    return data.profile_picture;
  } catch (error) {
    console.error('Error fetching profile picture: ', error);
    return null;
  }
}

/**
 * Subir foto de perfil del usuario
 * @author gabrielm
 * @param {object} params
 * @param {File} params.file - The file to upload
 */
export async function uploadProfilePicture({ file }) {
  try {
    const formData = new FormData();
    formData.append('profile_picture', file);

    const response = await fetch(BASE_URL + 'insurance/profile-picture/', {
      method: 'POST',
      headers: {
        ...getAuthHeader(),
      },
      body: formData,
    });

    if (!response.ok) {
      const data = await response.json();
      throw new Error(data.error);
    }

    const data = await response.json();
    return { type: 'success', message: data.message };
  } catch (error) {
    console.error('Error uploading profile picture: ', error);
    return { type: 'error', message: 'Error al subir la foto de perfil' };
  }
}

/**
 * Check if master or call center user can add requirements to case
 * @author gabrielm
 * @param {string | undefined} userId - User ID, or `undefined` to use current user
 * @param {number} clientId - Client ID
 */
export async function canAddRequirementsToCaseCallCenter(userId, clientId) {
  const params = new URLSearchParams({
    user_id: userId,
    client_id: clientId,
  });
  const response = await fetch(
    `${BASE_URL}insurance/can-add-requirements-company-client/?${params.toString()}`,
    {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        ...getAuthHeader(),
      },
    }
  );

  if (!response.ok) {
    const errorData = await response.json();
    throw new Error(errorData.message || 'Error obteniendo permisos del usuario');
  }

  /** @type {{can_add_requirements: boolean}} */
  const data = await response.json();
  return data;
}

/**
 * Update if call center/master user can add requirements to case for a client.
 * @param {string} userId
 * @param {number|string} clientId
 * @param {boolean} canAddRequirements
 */
export async function updateCanAddRequirementsToCaseCallCenter(
  userId,
  clientId,
  canAddRequirements
) {
  const response = await fetch(`${BASE_URL}insurance/can-add-requirements-company-client/`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...getAuthHeader(),
    },
    body: JSON.stringify({
      user_id: userId,
      client_id: clientId,
      can_add_requirements: !!canAddRequirements,
    }),
  });

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    throw new Error(errorData.message || 'Error actualizando permiso de requerimientos');
  }

  return await response.json();
}

/**
 * Create or associate a Doctor record for an existing user and assign centers.
 * Uses the legacy endpoint at `insurance/doctores/create/` which accepts form-data
 * and a `user_id` field to link an existing user.
 * @param {object} params
 * @param {string} params.userID
 * @param {string} params.nombre - Name of the doctor (optional, will fallback to user name)
 * @param {number[]} params.centerIDs
 */
export async function createOrAssociateDoctor({ userID, nombre, centerIDs = [] }) {
  try {
    const form = new FormData();
    if (nombre) form.append('nombre', nombre);
    form.append('user_id', userID);
    // append multiple medical_center_ids so backend getlist() works
    (centerIDs || []).forEach(id => form.append('medical_center_ids', String(id)));

    const response = await fetch(BASE_URL + 'insurance/doctores/create/', {
      method: 'POST',
      headers: {
        ...getAuthHeader(),
      },
      body: form,
    });

    if (!response.ok) {
      const data = await response.json().catch(() => ({}));
      throw new Error(data.error || data.message || 'Error creando/actualizando doctor');
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error creating/associating doctor: ', error);
    return { type: 'error', message: 'Error creando/actualizando doctor' };
  }
}

/**
 * Save medical center associations for a user.
 * @param {object} params
 * @param {string} params.userID
 * @param {number[]} params.centerIDs
 */
export async function saveUserMedicalCenters({ userID, centerIDs = [] }) {
  try {
    const response = await fetch(BASE_URL + 'insurance/user-medical-centers/', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        ...getAuthHeader(),
      },
      body: JSON.stringify({ user_id: userID, medical_center_ids: centerIDs }),
    });

    if (!response.ok) {
      const data = await response.json().catch(() => ({}));
      throw new Error(data.detail || data.error || 'Error sincronizando centros médicos');
    }

    return await response.json();
  } catch (error) {
    console.error('Error saving user medical centers:', error);
    return { type: 'error', message: 'Error sincronizando centros médicos' };
  }
}

/**
 * Set whether a Call Center or Master user can add requirements to a case
 * @author gabrielm
 * @param {object} params
 * @param {string} params.userId - User ID
 * @param {string} params.clientId - Client ID
 * @param {boolean} params.canAdd - Whether the user can add requirements
 */
export async function setCanAddRequirementsToCaseCallCenter({ userId, clientId, canAdd }) {
  const response = await fetch(BASE_URL + 'insurance/can-add-requirements-company-client/', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...getAuthHeader(),
    },
    body: JSON.stringify({
      user_id: userId,
      client_id: clientId,
      can_add_requirements: canAdd,
    }),
  });

  if (!response.ok) {
    const errorData = await response.json();
    throw new Error(errorData.message || 'Error actualizando permisos del usuario');
  }

  return { type: 'success', message: 'Permiso actualizado correctamente' };
}

/**
 * Get permissions for the current user
 * @author gabrielm
 */
export async function getPermissions() {
  const response = await fetch(`${BASE_URL}user-permissions/`, {
    headers: getAuthHeader(),
  });
  if (!response.ok) {
    return {};
  }
  const data = await response.json();
  return data.permissions;
}
